import { Separator, Skeleton } from '@monksflow/monks-ui';

export const SparkSkeletonCard = () => {
  return (
    <div className="flex w-full flex-col rounded-lg border border-border-light bg-transparent">
      <div className="flex gap-8 items-start p-6">
        <Skeleton className="shrink-0 size-25 rounded-full" data-testid="skeleton-loader" />

        <div className="flex flex-col gap-5 flex-1 min-w-0 pt-1">
          <div className="flex flex-col gap-2">
            <Skeleton className="h-6 w-[90%]" data-testid="skeleton-loader" />
            <Skeleton className="h-6 w-[75%]" data-testid="skeleton-loader" />
            <Skeleton className="h-6 w-[60%]" data-testid="skeleton-loader" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-30" data-testid="skeleton-loader" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-24" data-testid="skeleton-loader" />
              <Separator orientation="vertical" className="h-4" />
              <Skeleton className="h-4 w-16" data-testid="skeleton-loader" />
            </div>
          </div>
        </div>
      </div>

      <div className="mx-6 mb-6 border border-neutral-100 rounded-lg p-4 flex gap-4 items-start">
        <Skeleton className="shrink-0 size-8" data-testid="skeleton-loader" />
        <div className="flex flex-col gap-2 flex-1">
          <Skeleton className="h-4 w-full" data-testid="skeleton-loader" />
          <Skeleton className="h-4 w-[70%]" data-testid="skeleton-loader" />
          <Skeleton className="h-4 w-24 mt-1" data-testid="skeleton-loader" />
        </div>
      </div>
    </div>
  );
};
